import"./index-8p04sssx.mjs";
import {
  createColorMatrixImplementations
} from "./index-cdp7tr8x.mjs";
import {
  DEFAULT_AMOUNT,
  colorAmountSchema,
  assertOptionalFiniteNumber,
  validateUnitInterval
} from "./index-wxhvgv2s.mjs";
import {
  assertEffectParamsObject
} from "./index-4fvp93ps.mjs";

// src/grayscale.ts
import { Internals } from "remotion";
var { createEffect } = Internals;
var grayscaleSchema = {
  amount: colorAmountSchema
};
var resolve = (p) => ({
  amount: p.amount ?? DEFAULT_AMOUNT
});
var validateGrayscaleParams = (params) => {
  assertEffectParamsObject(params, "Grayscale");
  assertOptionalFiniteNumber(params.amount, "amount");
  const { amount } = resolve(params);
  validateUnitInterval(amount, "amount");
};
var grayscale = createEffect({
  type: "dev.remotion.effects.grayscale",
  label: "grayscale()",
  documentationLink: "https://www.remotion.dev/docs/effects/grayscale",
  calculateKey: (params) => {
    const r = resolve(params);
    return `grayscale-${r.amount}`;
  },
  implementations: {
    ...createColorMatrixImplementations("grayscale", (params) => {
      const { amount } = resolve(params);
      const red = 0.2126 * amount;
      const green = 0.7152 * amount;
      const blue = 0.0722 * amount;
      return new Float32Array([
        1 - amount + red,
        green,
        blue,
        0,
        red,
        1 - amount + green,
        blue,
        0,
        red,
        green,
        1 - amount + blue,
        0,
        0,
        0,
        amount === 0 ? 1 : 0,
        0
      ]);
    }),
    "2d": Internals.createEffectImplementation({
      setup: () => null,
      apply: ({ source, target, width, height, params }) => {
        const ctx = target.getContext("2d");
        if (!ctx) {
          throw new Error("Failed to acquire 2D context for grayscale effect. The canvas may have been assigned a different context type.");
        }
        const r = resolve(params);
        ctx.clearRect(0, 0, width, height);
        ctx.filter = `grayscale(${r.amount * 100}%)`;
        ctx.drawImage(source, 0, 0, width, height);
        ctx.filter = "none";
      },
      cleanup: () => {
        return;
      }
    })
  },
  schema: grayscaleSchema,
  validateParams: validateGrayscaleParams
});
export {
  grayscale
};
